import React, { useEffect } from "react"
/** @jsx jsx */
import { jsx } from "theme-ui"
import styled from "styled-components"
import theme, { rem } from "@src/theme"

const HubspotEmbed = ({
    portalId,
    formId,
    region = 'na1',
}) => {
    const formHtml = `
      <script src="https://js.hsforms.net/forms/embed/developer/${portalId}.js" defer></script>
      <div class="hs-form-html" data-region="${region}" data-form-id="${formId}" data-portal-id="${portalId}"></div>
    `;

    useEffect(() => {
        // Re-run scripts after component mounts since dangerouslySetInnerHTML doesn't execute them
        const scripts = document.querySelectorAll(`script[src*="${portalId}.js"]`);
        scripts.forEach(script => {
            if (script.parentNode) {
                const newScript = document.createElement('script');
                newScript.src = script.src;
                newScript.defer = script.defer;
                script.parentNode.replaceChild(newScript, script);
            }
        });

        // Wait a bit for HubSpot script to load, then set up listeners
        // setTimeout(setupHubSpotEventListeners, 500);
    }, [portalId, formId]);

    if (!portalId || !formId) {
        return (
            <div className={`hubspot-form-error ${className}`}>
                <p>Error: Missing required HubSpot form configuration</p>
            </div>
        );
    }

    return (
        <FormWrapper
            sx={{
                'button[type="submit"]': {
                    fontSize: [rem(16), null, rem(18), rem(20)],
                }
            }}
            dangerouslySetInnerHTML={{ __html: formHtml }}
        />
    );
};

export default HubspotEmbed;


const FormWrapper = styled.div`

.hsfc-Step .hsfc-Step__Content {
    padding: 0!important;
}


.hsfc-NavigationRow {
    margin-top:0!important;
    .hsfc-Button {
    margin-right: auto;
    }
}


.hsfc-RichText {
    font-family: ${theme.fonts.body}!important;
    color: ${theme.colors.darkPurple}!important;
    p:first-of-type {
        margin-top: 0!important;
    }
    ul li {
        margin-bottom: ${rem(8)}!important;
    }
}


.hsfc-FieldLabel {
    color: ${theme.colors.darkPurple}!important;
}

.hsfc-CheckboxFieldGroup__Options {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  font-size: ${rem(18)}!important;

}

.hsfc-Step {
    .hsfc-RichText {
      p:first-of-type {
        margin-top: 0;
        color: ${theme.colors.darkPurple}!important;
        font-family: ${theme.fonts.body}!important;
        color: ${theme.colors.darkPurple}!important;
      }
    }
}


.hsfc-CheckboxFieldGroup {

> label.hsfc-FieldLabel {
    display: none;
}
}

.hsfc-ErrorAlert {
color: ${theme.colors.red}!important;
}
.hsfc-ErrorAlert,
.hsfc-FieldLabel {
  font-family: ${theme.fonts.body}!important;
}



.hsfc-CheckboxInput {
border-radius: 0!important;
border-color: #3A2A55!important;
}

.hsfc-CheckboxInput:checked:after {
background-color: #3A2A55!important;
}

.hsfc-TextInput {
  border: 3px solid ${theme.colors.grey}!important;
  padding: ${rem(10)}!important;
  font-size: ${rem(18)}!important;
  font-family: ${theme.fonts.body}!important;
  border-radius: 0!important;
  color: ${theme.colors.darkPurple}!important;
  background: transparent!important;
}

button[type="submit"] {
    border-radius: 0!important;
    text-transform: uppercase!important;
    border: none!important;
    padding-left: ${rem(22)}!important;
    padding-right: ${rem(22)}!important;
    padding-top: ${rem(18)};
    padding-bottom: ${rem(16)};
    background-color: ${theme.colors.darkPurple}!important;
    font-family: ${theme.fonts.heading}!important;

}

.hsfc-FieldLabel__RequiredIndicator {
    color: ${theme.colors.darkPurple}!important;
}

.hsfc-DropdownField {
    .hsfc-FieldLabel {
        span {
            font-size: ${rem(18)}!important;
            color: ${theme.colors.darkPurple}!important;
        }
    }
}

.hsfc-FieldDescription {
    span {
        color: ${theme.colors.darkPurple}!important;
    }
}
`
